module.exports = __webpack_public_path__ + "img/hyyy.8037bcb3.jpg";